import React from 'react';
import { Grid } from '@material-ui/core';

import TokenInfo from './TokenInfo';

import { useStyles } from './styles.module';

const PoolContent = ({ poolInfo }) => {
  const classes = useStyles();

  if (!poolInfo) return null;

  return (
    <Grid
      container
      item
      direction="column"
      className={classes.content}
    >
      <Grid item spacing={2} container direction="column" className={classes.text}>
        <Grid item className={classes.title}>Asset Allocation</Grid>
        <Grid item className={classes.description}>Breakdown of total assets in this fund</Grid>
      </Grid>
      <Grid container spacing={6} item>
        {
          poolInfo.tokens.map(token => {
            const usdPrice = poolInfo.tokenPrices.find(item => item.address === token.toLowerCase());
            const balance = poolInfo.balances.find(item => item.address === token.toLowerCase());
            const weight = poolInfo.weights.find(item => item.address === token.toLowerCase());

            if (!usdPrice && !balance && !weight) return <div>Loading</div>;

            return (
              <Grid container item lg={6} key={token}>
                <TokenInfo
                  poolInfo={poolInfo}
                  usdPrice={usdPrice?.usdPrice}
                  weight={weight?.weight}
                  balance={balance?.balance}
                  poolToken={token}
                />
              </Grid>
            );
          })
        }
      </Grid>
    </Grid>
  );
};

export default PoolContent;
